import React from "react";
import { EyeOutlined } from "@ant-design/icons";
import Table from "antd/lib/table";
import styled from "styled-components";
import { CircleIndicator } from "components/circleIndicator";
import { Colors } from "helpers/colors";
import { OrderGroup, Task } from "./tasks";

interface Props {
  orders: OrderGroup[];
  setSelectedTask: (task: Task) => void;
  userRole: string;
}

const statusColors: any = {
  "Not Started": { inner: "#F31F13", outer: "#FBBBB8" },
  "In Progress": { inner: "#DD951F", outer: "#FCE5C6" },
  Completed: { inner: "#04A468", outer: "#B3E4D1" }
};

export const TasksTable: React.FC<Props> = ({
  orders,
  setSelectedTask,
  userRole
}) => {
  return (
    <>
      {orders.map(order => (
        <OrderContainer key={order.templateId}>
          <OrderTitle>
            {order.orderName} ({order.templateId})
          </OrderTitle>
          <TableWrapper>
            <Table
              dataSource={order.tasks}
              rowKey="id"
              pagination={false}
              rowClassName={record =>
                record.implementorRole !== userRole ? "task-row-disabled" : ""
              }
              columns={[
                {
                  title: "Task",
                  dataIndex: "taskName",
                  width: 180,
                  className: "bg-grey"
                },
                // {
                //   title: "Sub Tasks",
                //   dataIndex: "subTasks",
                //   render: (subTasks: string[]) => (
                //     <List>
                //       {subTasks?.map((item, i) => (
                //         <li key={i}>{item}</li>
                //       ))}
                //     </List>
                //   )
                // },
                {
                  title: "Assigned To",
                  dataIndex: "assignedTo",
                  width: 160
                },
                {
                  title: "Role",
                  dataIndex: "implementorRole",
                  width: 160
                },
                // {
                //   title: "Consumables",
                //   dataIndex: "consumables",
                //   render: (items: string[]) =>
                //     items?.length ? items.join(", ") : "—"
                // },
                {
                  title: "Key Actions",
                  dataIndex: "keyActions",
                  width: 220
                },
                {
                  title: "Status",
                  dataIndex: "status",
                  width: 150,
                  render: (status: string) => (
                    <StatusRow>
                      <CircleIndicator
                        outerColor={statusColors[status].outer}
                        innerColor={statusColors[status].inner}
                      />
                      {status}
                    </StatusRow>
                  )
                },
                {
                  title: "Action",
                  width: 80,
                  render: (_: any, task: Task) => {
                    const disabled = userRole !== task.implementorRole;

                    return (
                      <EyeOutlined
                        style={{
                          fontSize: 18,
                          color: disabled ? "#BFBFBF" : Colors.LightGrey,
                          cursor: disabled ? "not-allowed" : "pointer"
                        }}
                        onClick={() => {
                          if (!disabled) setSelectedTask(task);
                        }}
                      />
                    );
                  }
                }
              ]}
            />
          </TableWrapper>
        </OrderContainer>
      ))}
    </>
  );
};

const OrderContainer = styled.div`
  margin-bottom: 28px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fff;
`;

const OrderTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding: 14px 18px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
`;

const StatusRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
`;

const TableWrapper = styled.div`
  padding: 10px;

  .ant-table {
    border-radius: 6px;
  }

  .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
  }

  .task-row-disabled {
    background: #f5f5f5 !important;
    color: #9e9e9e;
    opacity: 0.65;
    pointer-events: none;
  }

  .task-row-disabled td {
    background: #f5f5f5 !important;
    color: #9e9e9e !important;
  }

  .task-row-disabled:hover td {
    background: #f5f5f5 !important;
  }
`;

const List = styled.ul`
  margin: 0;
  padding-left: 18px;

  li {
    margin-bottom: 4px;
    line-height: 1.4;
  }
`;
